import { createReducer, on } from '@ngrx/store';
import { AppleDeviceApiActions } from './certificate.actions';
import { adapter, initialState } from './certificate.state';

export const MdmCertificateFeatureKey = 'mdm-certificate';

export const CertficateReducer = createReducer(
  initialState,
  on(AppleDeviceApiActions.certificatesLoaded, (state, { certificates }) => adapter.upsertMany(certificates, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCertificateIds = selectIds;

export const selectCertificateEntities = selectEntities;

export const selectCertificates = selectAll;
